// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"331":"1b22f238","652":"160eca78"}[chunkId] + ".css";
};